import i18n from "@mirage/translations";
import type { WorkflowStep } from "./types";

export const getWorkflowSteps = () => {
  const Step1: WorkflowStep = {
    name: i18n.t("assistant_ai_tool_tool_type_header"),
    step: 1,
    inputs: [
      {
        id: "type",
        name: i18n.t("assistant_ai_tool_type_label"),
        description: i18n.t("assistant_ai_tool_type_label_description"),
        type: "tile-select",
        required: true,
        addedOptions: [],
        availableOptions: [
          {
            id: "conversations",
            label: i18n.t("assistant_ai_tool_type_chat_label"),
            description: i18n.t(
              "assistant_ai_tool_type_chat_label_description",
            ),
            isSelected: true,
          },
          {
            id: "write",
            label: i18n.t("assistant_ai_tool_type_write_label"),
            description: i18n.t(
              "assistant_ai_tool_type_write_label_description",
            ),
            disabled: true,
          },
          {
            id: "analysis",
            label: i18n.t("assistant_ai_tool_type_analysis_label"),
            description: i18n.t(
              "assistant_ai_tool_type_analysis_label_description",
            ),
            disabled: true,
          },
        ],
      },
    ],
  };

  const Step2: WorkflowStep = {
    name: i18n.t("assistant_ai_tool_behavior_header"),
    step: 2,
    inputs: [
      {
        id: "base-model",
        name: i18n.t("assistant_ai_tool_base_model"),
        type: "model-select",
        required: true,
      },
      {
        id: "prompt",
        name: i18n.t("assistant_ai_tool_system_prompt"),
        type: "paragraph",
        required: true,
        description: i18n.t("assistant_ai_tool_system_prompt_description"),
        placeholder: i18n.t("assistant_ai_tool_system_prompt_placeholder"),
      },
      {
        id: "web-search",
        name: i18n.t("assistant_ai_tool_dash_search"),
        type: "boolean",
        required: false,
        description: i18n.t("assistant_ai_tool_dash_search_description"),
      },
      {
        id: "suggestions",
        name: i18n.t("assistant_ai_tool_suggestions"),
        type: "boolean",
        required: false,
        description: i18n.t("assistant_ai_tool_suggestions_description"),
        isSelected: true,
      },
    ],
  };

  const Step3: WorkflowStep = {
    name: i18n.t("assistant_ai_tool_workflow_header"),
    step: 3,
    inputs: [
      {
        id: "step-1",
        name: i18n.t("assistant_ai_tool_step_name", { stepIndex: 1 }),
        type: "combo-step",
        comboInputs: [
          {
            id: "prompt",
            name: i18n.t("assistant_ai_tool_user_prompt"),
            type: "text",
            required: true,
            placeholder: i18n.t("assistant_ai_tool_user_prompt_placeholder"),
            maxLength: 100,
          },
          {
            id: "prompt-type",
            name: i18n.t("assistant_ai_tool_prompt_type"),
            type: "select",
            required: true,
            addedOptions: [],
            availableOptions: [
              {
                id: "open",
                label: i18n.t("assistant_ai_tool_prompt_type_open"),
                isSelected: true,
              },
              {
                id: "template",
                label: i18n.t("assistant_ai_tool_prompt_type_template"),
                disabled: true,
              },
              {
                id: "tone",
                label: i18n.t("assistant_ai_tool_prompt_type_tone"),
                disabled: true,
              },
              {
                id: "search",
                label: i18n.t("assistant_ai_tool_prompt_type_search"),
                disabled: true,
              },
            ],
          },
        ],
        required: true,
        description: i18n.t("assistant_ai_tool_chat_step_1_description"),
      },
    ],
  };

  const Step4: WorkflowStep = {
    name: i18n.t("assistant_ai_tool_knowledge_header"),
    step: 4,
    inputs: [
      {
        id: "sources",
        name: i18n.t("assistant_ai_tool_sources"),
        type: "source-select",
        required: false,
      },
      {
        id: "custom-sources",
        name: i18n.t("assistant_ai_tool_custom_sources"),
        type: "boolean",
        description: i18n.t("assistant_ai_tool_custom_sources_description"),
        required: false,
      },
    ],
  };

  const Step5: WorkflowStep = {
    name: i18n.t("assistant_ai_tool_publish_header"),
    step: 5,
    inputs: [
      {
        id: "name",
        name: i18n.t("assistant_ai_tool_name"),
        type: "text",
        description: i18n.t("assistant_ai_tool_name_description"),
        placeholder: i18n.t("assistant_ai_tool_name_placeholder"),
        required: true,
        maxLength: 100,
      },
      {
        id: "icon",
        name: i18n.t("assistant_ai_tool_icon"),
        type: "icon-select",
        required: false,
        group: "appearance",
      },
      {
        id: "theme",
        name: i18n.t("assistant_ai_tool_theme"),
        type: "color-select",
        required: false,
        group: "appearance",
      },
      {
        id: "description",
        name: i18n.t("assistant_ai_tool_description"),
        type: "paragraph",
        description: i18n.t("assistant_ai_tool_description_description"),
        placeholder: i18n.t("assistant_ai_tool_description_placeholder"),
        required: true,
        maxLength: 500,
      },
      {
        id: "publish",
        name: i18n.t("assistant_ai_tool_publish_label"),
        type: "radio-select",
        description: i18n.t("assistant_ai_tool_publish_description"),
        required: true,
        availableOptions: [
          {
            id: "private",
            label: i18n.t("assistant_ai_tool_publish_private"),
            isSelected: true,
          },
          {
            id: "company",
            label: i18n.t("assistant_ai_tool_publish_company"),
            description: i18n.t(
              "assistant_ai_tool_publish_company_description",
            ),
          },
        ],
      },
    ],
  };

  return [Step1, Step2, Step3, Step4, Step5];
};
